import React from 'react';
import ReactDOM from 'react-dom';
import CommonSnackbar from '../common/SnackBar';

interface ToasterPortalProps {
  open: boolean;
  type: 'success' | 'warning' | 'error';
  message: string;
  onClose: () => void;
}

function ToasterPortal({ open, type, message, onClose }: ToasterPortalProps) {
  return ReactDOM.createPortal(
    <CommonSnackbar
      open={open}
      type={type}
      message={message}
      onClose={onClose}
    />,
    document.getElementById('toaster-root') as HTMLElement,
  );
}

export default ToasterPortal;
